<template>
  <a-box>
    <l-rows>
      <a-title
        :text="$t('versions.jurisdictions')"
        size="4"
      />
      <form @submit.prevent="addJurisdiction">
        <l-rows>
          <l-rows tag="ul">
            <li
              v-for="jurisdiction in jurisdictionsValues"
              :key="jurisdiction.id"
            >
              <l-columns
                centered-y
                space="between"
              >
                <div>{{ jurisdiction.key }}</div>
                <a-button
                  icon-left="fas fa-trash"
                  variant="primary"
                  type="button"
                  aria-label="Delete integration option"
                  @click="deleteJurisdiction(jurisdiction)"
                />
              </l-columns>
            </li>
          </l-rows>
          <l-columns>
            <a-select
              v-model="selectedJurisdictionValue"
              fullwidth
              :options="filteredOptions"
            />
            <l-columns-column size="narrow">
              <a-button
                :text="$t('common.add')"
                variant="primary"
              />
            </l-columns-column>
          </l-columns>
        </l-rows>
      </form>
    </l-rows>
  </a-box>
</template>

<script>
  import { ABox, AButton, ASelect, ATitle, LColumns, LColumnsColumn, LRows } from 'codefabrik-gui-vue'
  import { useJurisdictionPage } from '@/views/casinos/casinoHooks'

  export default {
    name: 'GameJurisdictions',
    components: { ABox, LRows, ATitle, LColumns, ASelect, LColumnsColumn, AButton },
    props: {
      value: {
        type: Array,
        default () { return [] }
      }
    },
    data () {
      return {
        selectedJurisdictionValue: null
      }
    },
    computed: {
      jurisdictions () {
        return this.jurisdictionPage.jurisdictions || []
      },
      options () {
        return [
          {
            label: this.$t('versions.selectJurisdiction'),
            value: null
          },
          ...this.jurisdictions.map(it => ({
            label: it.key,
            value: it.id
          }))
        ]
      },
      filteredOptions () {
        const values = this.value.map(it => it.id);
        return this.options.filter(it => !values.includes(it.value))
      },
      jurisdictionsValues () {
        return this.value.map(it => it.id)
          .map(it => this.jurisdictions.find(option => option.id === it))
          .filter(it => it !== undefined)
      }
    },
    methods: {
      addJurisdiction () {
        if (this.selectedJurisdictionValue == null) return

        this.$emit('input', [
          ...this.value,
          {id: this.selectedJurisdictionValue}
        ])
        const indexOf = this.filteredOptions.findIndex(it => it.value === this.selectedJurisdictionValue) + 1
        const nextOption = this.filteredOptions[Math.min(indexOf, this.filteredOptions.length)]
        this.selectedJurisdictionValue = nextOption ? nextOption.value : null
      },
      deleteJurisdiction (option) {
        this.$emit(
          'input',
          this.value.filter(it => it.id !== option.id)
        )
      }
    },
    mixins: [useJurisdictionPage({ limit: 0 })]
  }
</script>

<style scoped>

</style>
